import PropTypes from 'prop-types';
import { useCallback } from 'react';

import { Stack, MenuItem, Checkbox, TextField, InputLabel, IconButton, FormControl, OutlinedInput, InputAdornment, Select, Tooltip } from '@mui/material';
import Iconify from '../../components/iconify/index.js';
import { DatePicker } from '@mui/x-date-pickers';

export default function SubscriptionTableToolBar({
    filters,
    onFilters,
    subscription,
    onExportCSV
}) {
    // const popover = usePopover();

    const handleFilterName = useCallback((event) => {
        onFilters('subscription', event.target.value)
    }, [onFilters])

    const handleDateFrom = useCallback((event) => {
        onFilters('year', event)
    }, [onFilters])

    return (
        <>
            <Stack
                spacing={2}
                alignItems={{ xs: 'flex-end', md: 'center' }}
                direction={{
                    xs: 'column',
                    md: 'row'
                }}
                sx={{
                    p: 2.5,
                    pr: { xs: 2.5, md: 1 }
                }}
            >

                <Stack direction="row" alignItems="center" spacing={2} flexGrow={1} sx={{ width: 1 }} >

                    <FormControl sx={{
                        width: 320
                    }}>
                        <InputLabel id="demo-simple-select-label">Subscriptions</InputLabel>
                        <Select
                            labelId="demo-simple-select-label"
                            id="demo-simple-select"
                            label="Subscriptions"
                            onChange={handleFilterName}
                            value={filters?.subscription}

                        >
                            {subscription?.results?.map((item) => {
                                return (
                                    <MenuItem key={item._id} value={item.title} sx={{ fontStyle: 'italic', color: 'text.secondary' }}>
                                        {item.title}
                                    </MenuItem>
                                )
                            })}
                        </Select>
                    </FormControl>

                    <DatePicker
                        views={['year']}
                        label="Year"
                        onChange={handleDateFrom}
                        value={filters?.year}
                        slotProps={{
                            textField: {
                                fullWidth: true
                            },
                        }}
                        sx={{ width: 320 }}
                        renderInput={(params) => <TextField {...params} />}
                    />

                                <Tooltip title="Export CSV">
                                        <IconButton color="secondary" onClick={onExportCSV} sx={{ width: 50, height: 50 }}>
                                            <Iconify icon="hugeicons:csv-02" />
                                        </IconButton>
                                     </Tooltip>

                </Stack>


            </Stack>
        </>
    )
}

SubscriptionTableToolBar.propTypes = {
    filters: PropTypes.object,
    onFilters: PropTypes.func,
    subscription: PropTypes.array,
    onExportCSV: PropTypes.func
}